
import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

let socketInstance = null; // Global reference to reuse the same socket
const apiUrl = process.env.REACT_APP_SOCKET_URL?.trim();

const useSocket = (token) => {
console.log("apiUrl",apiUrl)
  const [socket, setSocket] = useState(null);
console.log("0000000000000000000000000",token)
  useEffect(() => {
   console.log("))))))))))))))))))))))))))))))))))))))))))")
   console.log("token",token)
   console.log("apiUrl",apiUrl)
   if (!token || !apiUrl) {
    console.log("Missing token or API URL, cannot connect to socket.");
    console.log("token",token)
    console.log("apiUrl",apiUrl)
    return;
  }
    if (!socketInstance) {
      console.log("Creating new socket connection...");

      socketInstance = io(apiUrl, {
        extraHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      socketInstance.on("connect", () => {
        console.log("Socket connected:", socketInstance?.id);
      });

      socketInstance.on("disconnect", () => {
        console.log("Socket disconnected");
        socketInstance = null; 
      });

      setSocket(socketInstance);
    } else if (socketInstance) {
      console.log("Reusing existing socket connection");
      setSocket(socketInstance);
    }

    return () => {
    };
  }, []);

  return socket;
};

export default useSocket;